<template>
  <div class="font-sans bg-[#f6f4f1] text-[#1f2937] min-h-screen flex flex-col">
    <!-- HEADER -->
    <header class="bg-[#1a1a1a] text-white shadow sticky top-0 z-50">
      <div class="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
        <!-- LOGO -->
        <div class="flex items-center gap-2">
          <img src="/brand/getlance-logo.svg" alt="Logo GetLance" class="h-20 w-auto" />
        </div>

        <!-- NAV DESKTOP -->
        <nav class="hidden md:flex items-center gap-8">
          <a href="#para-quem" class="hover:text-[#b99a52] transition">Para quem é</a>
          <a href="#como-funciona" class="hover:text-[#b99a52] transition">Como funciona</a>
          <a href="#categorias" class="hover:text-[#b99a52] transition">Categorias</a>
          <a href="#seguranca" class="hover:text-[#b99a52] transition">Segurança</a>
        </nav>

        <!-- AÇÕES DESKTOP -->
        <div class="hidden md:flex items-center gap-3">
          <template v-if="!isAuthenticated">
            <router-link to="/login"
              class="px-4 py-2 rounded-full border border-white/20 bg-white/10 hover:bg-white/20 transition whitespace-nowrap">
              Fazer login
            </router-link>
            <router-link to="/cadastro"
              class="px-4 py-2 rounded-full bg-[#b99a52] hover:bg-[#a18446] text-white transition whitespace-nowrap font-semibold">
              Cadastrar
            </router-link>
          </template>
          <div v-else class="relative" ref="avatarWrapRef">
            <button type="button"
              class="w-10 h-10 rounded-full bg-[#374151] hover:bg-[#4b5563] text-white font-semibold text-lg flex items-center justify-center transition focus:outline-none focus:ring-2 focus:ring-white/50 border border-white/20"
              :title="userName"
              @click="showDropdown = !showDropdown"
              aria-haspopup="true"
              :aria-expanded="showDropdown">
              {{ avatarLetter }}
            </button>
            <div v-if="showDropdown"
              class="absolute right-0 mt-2 w-52 py-2 bg-white rounded-xl shadow-lg border border-gray-200 text-[#1f2937] z-50">
              <div class="px-4 py-2 border-b border-gray-100">
                <p class="text-sm font-medium text-[#152a34] truncate" :title="userName">{{ userName }}</p>
              </div>
              <router-link to="/perfil" @click="showDropdown = false"
                class="block px-4 py-2.5 text-sm hover:bg-gray-50 transition">
                Meu Perfil
              </router-link>
              <router-link to="/meus-projetos" @click="showDropdown = false"
                class="block px-4 py-2.5 text-sm hover:bg-gray-50 transition">
                Meus Projetos
              </router-link>
              <router-link to="/meus-agendamentos" @click="showDropdown = false"
                class="block px-4 py-2.5 text-sm hover:bg-gray-50 transition">
                Meus Agendamentos
              </router-link>
              <div class="border-t border-gray-100 my-1"></div>
              <button type="button"
                class="w-full text-left px-4 py-2.5 text-sm hover:bg-red-50 hover:text-red-700 transition"
                @click="logout">
                Sair
              </button>
            </div>
          </div>
        </div>

        <!-- MENU MOBILE -->
        <button class="md:hidden text-2xl leading-none" @click="showMenu = true" aria-label="Abrir menu">
          ☰
        </button>
      </div>

      <!-- DRAWER MOBILE -->
      <div v-if="showMenu" class="fixed inset-0 bg-black/40 backdrop-blur-sm z-[999] flex md:hidden"
        @click.self="showMenu = false">
        <div class="w-80 max-w-[85vw] bg-white text-[#152a34] h-full p-6 overflow-y-auto shadow-xl animate-slideLeft">
          <div class="flex items-center justify-between mb-4">
            <h2 class="text-lg font-semibold">Menu</h2>
            <button class="text-gray-500 text-xl" @click="showMenu = false" aria-label="Fechar menu">✕</button>
          </div>

          <!-- LINKS -->
          <nav class="space-y-2">
            <a href="#para-quem" class="block px-3 py-2 rounded-xl hover:bg-gray-100"
              @click="closeAndScroll('#para-quem')">Para quem é</a>
            <a href="#como-funciona" class="block px-3 py-2 rounded-xl hover:bg-gray-100"
              @click="closeAndScroll('#como-funciona')">Como funciona</a>
            <a href="#categorias" class="block px-3 py-2 rounded-xl hover:bg-gray-100"
              @click="closeAndScroll('#categorias')">Categorias</a>
            <a href="#seguranca" class="block px-3 py-2 rounded-xl hover:bg-gray-100"
              @click="closeAndScroll('#seguranca')">Segurança</a>
          </nav>

          <div class="my-6 border-t"></div>

          <!-- CTAs -->
          <div class="space-y-3">
            <template v-if="!isAuthenticated">
              <router-link to="/login"
                class="block w-full text-center px-4 py-3 rounded-xl border border-[#e0dcd6] bg-white hover:bg-gray-50 transition font-semibold"
                @click="showMenu = false">
                Fazer login
              </router-link>

              <router-link to="/cadastro"
                class="block w-full text-center px-4 py-3 rounded-xl bg-[#b99a52] hover:bg-[#a18446] text-white transition font-semibold"
                @click="showMenu = false">
                Cadastrar grátis
              </router-link>
            </template>
            <template v-else>
              <router-link to="/perfil"
                class="block w-full text-center px-4 py-3 rounded-xl border border-[#e0dcd6] bg-white hover:bg-gray-50 transition font-semibold"
                @click="showMenu = false">
                Meu Perfil
              </router-link>
              <router-link to="/meus-projetos"
                class="block w-full text-center px-4 py-3 rounded-xl border border-[#e0dcd6] bg-white hover:bg-gray-50 transition font-semibold"
                @click="showMenu = false">
                Meus Projetos
              </router-link>
              <button
                class="block w-full text-center px-4 py-3 rounded-xl bg-red-50 border border-red-200 hover:bg-red-100 text-red-700 transition font-semibold"
                @click="logout">
                Sair
              </button>
            </template>
          </div>
        </div>

        <div class="flex-1"></div>
      </div>
    </header>

    <!-- ===================================================== -->
    <!-- HERO — Proposta + 3 caminhos claros (alta conversão)  -->
    <!-- ===================================================== -->
    <section class="relative bg-[#152a34] text-white overflow-hidden">
      <!-- Background gradiente sutil -->
      <div class="absolute inset-0 bg-gradient-to-br from-[#152a34] via-[#1a3543] to-[#0f1f27]"></div>
      <div class="absolute inset-0 opacity-30"
        style="background-image: radial-gradient(circle at 20% 20%, #b99a52 0%, transparent 40%), radial-gradient(circle at 80% 80%, #b99a52 0%, transparent 40%);">
      </div>

      <div class="relative max-w-7xl mx-auto px-4 sm:px-6 pt-14 pb-12 sm:pt-20 sm:pb-16">
        <!-- Selo de proposta -->
        <div class="flex justify-center mb-6">
          <span class="inline-flex items-center gap-2 px-4 py-1.5 rounded-full
                       bg-[#b99a52]/15 border border-[#b99a52]/40 text-[#e6d4a3] text-xs font-semibold tracking-wide uppercase">
            <span class="w-2 h-2 rounded-full bg-[#b99a52] animate-pulse"></span>
            Marketplace de freelancers e prestadores presenciais
          </span>
        </div>

        <!-- Headline -->
        <h1 class="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-center leading-tight mb-5">
          Conecte <span class="text-[#b99a52]">talento</span> a <br class="hidden sm:block" />
          quem precisa de <span class="text-[#b99a52]">serviço</span>
        </h1>

        <p class="text-center text-white/85 text-lg sm:text-xl max-w-3xl mx-auto mb-10">
          Encontre freelancers remotos para projetos online ou contrate
          profissionais presenciais perto de você — tudo com chat integrado
          e pagamento com garantia GetLance.
        </p>

        <!-- ====== 3 CAMINHOS ====== -->
        <p class="text-center text-white/70 text-sm uppercase tracking-widest font-semibold mb-4">
          O que você procura hoje?
        </p>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-5 max-w-6xl mx-auto">
          <!-- CARD 1 — Contratar remoto -->
          <button type="button" @click="goToPublishProject"
            class="group text-left bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl hover:-translate-y-1
                   transition-all duration-200 flex flex-col h-full border-2 border-transparent
                   hover:border-[#b99a52] focus:outline-none focus:ring-2 focus:ring-[#b99a52] focus:ring-offset-2 focus:ring-offset-[#152a34]">
            <div class="w-12 h-12 rounded-xl bg-[#f4efe6] flex items-center justify-center mb-4">
              <svg viewBox="0 0 24 24" class="w-7 h-7 text-[#b99a52]" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="12" y1="18" x2="12" y2="12" />
                <line x1="9" y1="15" x2="15" y2="15" />
              </svg>
            </div>
            <span class="inline-flex w-fit text-[10px] font-bold uppercase tracking-wider bg-[#152a34] text-white px-2.5 py-1 rounded-full mb-2">
              Para contratantes
            </span>
            <h3 class="text-[#152a34] text-lg font-bold mb-2 leading-snug">
              Preciso contratar um freelancer
            </h3>
            <p class="text-gray-600 text-sm mb-5 flex-1">
              Você tem uma <strong>tarefa para delegar</strong>? Publique sua demanda, receba propostas de
              freelancers qualificados e pague apenas após aprovar a entrega.
            </p>
            <span class="inline-flex items-center justify-center gap-2 w-full px-4 py-2.5 rounded-xl
                         bg-[#b99a52] group-hover:bg-[#a18446] text-white font-semibold transition">
              Publicar minha demanda
              <svg class="w-4 h-4 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
              </svg>
            </span>
          </button>

          <!-- CARD 2 — Sou freelancer -->
          <router-link to="/projetos"
            class="group text-left bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl hover:-translate-y-1
                   transition-all duration-200 flex flex-col h-full border-2 border-transparent
                   hover:border-[#b99a52] focus:outline-none focus:ring-2 focus:ring-[#b99a52] focus:ring-offset-2 focus:ring-offset-[#152a34]">
            <div class="w-12 h-12 rounded-xl bg-[#f4efe6] flex items-center justify-center mb-4">
              <svg viewBox="0 0 24 24" class="w-7 h-7 text-[#b99a52]" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 13.255A23.931 23.931 0 0 1 12 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2m4 6h.01M5 20h14a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2z" />
              </svg>
            </div>
            <span class="inline-flex w-fit text-[10px] font-bold uppercase tracking-wider bg-[#0e7c5a] text-white px-2.5 py-1 rounded-full mb-2">
              Para freelancers
            </span>
            <h3 class="text-[#152a34] text-lg font-bold mb-2 leading-snug">
              Sou freelancer e quero novos projetos
            </h3>
            <p class="text-gray-600 text-sm mb-5 flex-1">
              Veja projetos abertos por categoria, envie propostas e
              construa sua reputação trabalhando remotamente.
            </p>
            <span class="inline-flex items-center justify-center gap-2 w-full px-4 py-2.5 rounded-xl
                         bg-[#152a34] group-hover:bg-[#0f1f27] text-white font-semibold transition">
              Ver projetos abertos
              <svg class="w-4 h-4 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
              </svg>
            </span>
          </router-link>

          <!-- CARD 3 — Buscar prestador presencial -->
          <router-link to="/buscar-prestadores"
            class="group text-left bg-white rounded-2xl p-6 shadow-lg hover:shadow-2xl hover:-translate-y-1
                   transition-all duration-200 flex flex-col h-full border-2 border-transparent
                   hover:border-[#b99a52] focus:outline-none focus:ring-2 focus:ring-[#b99a52] focus:ring-offset-2 focus:ring-offset-[#152a34]">
            <div class="w-12 h-12 rounded-xl bg-[#f4efe6] flex items-center justify-center mb-4">
              <svg viewBox="0 0 24 24" class="w-7 h-7 text-[#b99a52]" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17.657 16.657L13.414 20.9a1.998 1.998 0 0 1-2.827 0l-4.244-4.243a8 8 0 1 1 11.314 0z" />
                <circle cx="12" cy="11" r="3" />
              </svg>
            </div>
            <span class="inline-flex w-fit text-[10px] font-bold uppercase tracking-wider bg-[#7c3aed] text-white px-2.5 py-1 rounded-full mb-2">
              Serviços presenciais
            </span>
            <h3 class="text-[#152a34] text-lg font-bold mb-2 leading-snug">
              Preciso de um profissional perto de mim
            </h3>
            <p class="text-gray-600 text-sm mb-5 flex-1">
              Busque eletricistas, encanadores, manicures, personal trainers
              e mais — profissionais verificados na sua região.
            </p>
            <span class="inline-flex items-center justify-center gap-2 w-full px-4 py-2.5 rounded-xl
                         border-2 border-[#152a34] text-[#152a34] group-hover:bg-[#152a34] group-hover:text-white font-semibold transition">
              Buscar perto de mim
              <svg class="w-4 h-4 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
              </svg>
            </span>
          </router-link>
        </div>

        <!-- Link secundário: já tenho conta -->
        <div v-if="!isAuthenticated" class="text-center mt-8">
          <router-link to="/login" class="text-white/80 hover:text-white text-sm underline underline-offset-4">
            Já tenho conta · Fazer login
          </router-link>
        </div>
      </div>
    </section>

    <!-- ===================================================== -->
    <!-- FAIXA DE BENEFÍCIOS / PROVA SOCIAL                    -->
    <!-- ===================================================== -->
    <section class="bg-white border-y border-[#e0dcd6]">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 py-8 grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
        <div class="flex flex-col items-center gap-2">
          <div class="w-10 h-10 rounded-full bg-[#f4efe6] flex items-center justify-center">
            <svg viewBox="0 0 24 24" class="w-5 h-5 text-[#b99a52]" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M12 2 4 5v6c0 5 3.5 9.5 8 11 4.5-1.5 8-6 8-11V5l-8-3z" />
              <path d="m9 12 2 2 4-4" />
            </svg>
          </div>
          <p class="text-sm font-semibold text-[#152a34]">Pagamento com garantia</p>
          <p class="text-xs text-gray-500">Valor liberado só após aprovação</p>
        </div>
        <div class="flex flex-col items-center gap-2">
          <div class="w-10 h-10 rounded-full bg-[#f4efe6] flex items-center justify-center">
            <svg viewBox="0 0 24 24" class="w-5 h-5 text-[#b99a52]" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            </svg>
          </div>
          <p class="text-sm font-semibold text-[#152a34]">Chat integrado</p>
          <p class="text-xs text-gray-500">Negocie direto na plataforma</p>
        </div>
        <div class="flex flex-col items-center gap-2">
          <div class="w-10 h-10 rounded-full bg-[#f4efe6] flex items-center justify-center">
            <svg viewBox="0 0 24 24" class="w-5 h-5 text-[#b99a52]" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
              <circle cx="12" cy="7" r="4" />
            </svg>
          </div>
          <p class="text-sm font-semibold text-[#152a34]">Profissionais verificados</p>
          <p class="text-xs text-gray-500">Identidade conferida</p>
        </div>
        <div class="flex flex-col items-center gap-2">
          <div class="w-10 h-10 rounded-full bg-[#f4efe6] flex items-center justify-center">
            <svg viewBox="0 0 24 24" class="w-5 h-5 text-[#b99a52]" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="12" cy="12" r="10" />
              <polyline points="12 6 12 12 16 14" />
            </svg>
          </div>
          <p class="text-sm font-semibold text-[#152a34]">Resposta rápida</p>
          <p class="text-xs text-gray-500">Propostas em minutos</p>
        </div>
      </div>
    </section>

    <!-- ===================================================== -->
    <!-- PARA QUEM É — Segmentação detalhada                   -->
    <!-- ===================================================== -->
    <section id="para-quem" class="py-20 bg-[#f6f4f1] px-4 sm:px-6">
      <div class="max-w-7xl mx-auto">
        <div class="text-center mb-12">
          <h2 class="text-3xl sm:text-4xl font-bold text-[#152a34] mb-3">Para quem é o GetLance?</h2>
          <p class="text-gray-600 max-w-2xl mx-auto">
            Uma plataforma feita para conectar três perfis distintos —
            cada um com as ferramentas certas para encontrar o que precisa.
          </p>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-6 items-stretch">
          <!-- Contratantes -->
          <article class="bg-white rounded-2xl border border-[#e0dcd6] p-7 shadow-sm hover:shadow-md transition flex flex-col h-full">
            <div class="w-14 h-14 rounded-2xl bg-[#152a34] flex items-center justify-center mb-5">
              <svg viewBox="0 0 24 24" class="w-7 h-7 text-[#b99a52]" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="4" width="18" height="18" rx="2" />
                <line x1="16" y1="2" x2="16" y2="6" />
                <line x1="8" y1="2" x2="8" y2="6" />
                <line x1="3" y1="10" x2="21" y2="10" />
              </svg>
            </div>
            <h3 class="text-xl font-bold text-[#152a34] mb-3">Sou contratante — tenho uma tarefa para delegar</h3>
            <p class="text-gray-600 text-sm mb-5">
              Empresas e empreendedores que precisam contratar design, programação,
              marketing, redação, vídeo e mais — entregue 100% remoto por freelancers.
              <strong>Você descreve a tarefa; os profissionais enviam propostas.</strong>
            </p>
            <ul class="space-y-2.5 text-sm text-[#1f2937] mb-6">
              <li class="flex items-start gap-2">
                <span class="mt-0.5 text-[#0e7c5a]">✓</span>
                Publique sua demanda em menos de 3 minutos
              </li>
              <li class="flex items-start gap-2">
                <span class="mt-0.5 text-[#0e7c5a]">✓</span>
                Receba propostas de freelancers com prazo e preço
              </li>
              <li class="flex items-start gap-2">
                <span class="mt-0.5 text-[#0e7c5a]">✓</span>
                Pagamento liberado só após você aprovar a entrega
              </li>
            </ul>
            <button type="button" @click="goToPublishProject"
              class="mt-auto block w-full text-center px-4 py-2.5 rounded-xl bg-[#b99a52] hover:bg-[#a18446] text-white font-semibold transition">
              Publicar minha demanda gratuitamente
            </button>
          </article>

          <!-- Freelancers -->
          <article class="bg-white rounded-2xl border border-[#e0dcd6] p-7 shadow-sm hover:shadow-md transition flex flex-col h-full">
            <div class="w-14 h-14 rounded-2xl bg-[#152a34] flex items-center justify-center mb-5">
              <svg viewBox="0 0 24 24" class="w-7 h-7 text-[#b99a52]" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="2" y="3" width="20" height="14" rx="2" />
                <line x1="8" y1="21" x2="16" y2="21" />
                <line x1="12" y1="17" x2="12" y2="21" />
              </svg>
            </div>
            <h3 class="text-xl font-bold text-[#152a34] mb-3">Sou freelancer remoto</h3>
            <p class="text-gray-600 text-sm mb-5">
              Designers, devs, redatores, editores e qualquer profissional
              que entrega seu trabalho 100% online.
            </p>
            <ul class="space-y-2.5 text-sm text-[#1f2937] mb-6">
              <li class="flex items-start gap-2">
                <span class="mt-0.5 text-[#0e7c5a]">✓</span>
                Navegue projetos por categoria
              </li>
              <li class="flex items-start gap-2">
                <span class="mt-0.5 text-[#0e7c5a]">✓</span>
                Envie propostas com seu portfólio
              </li>
              <li class="flex items-start gap-2">
                <span class="mt-0.5 text-[#0e7c5a]">✓</span>
                Receba avaliações e construa reputação
              </li>
            </ul>
            <router-link to="/projetos"
              class="mt-auto block w-full text-center px-4 py-2.5 rounded-xl bg-[#152a34] hover:bg-[#0f1f27] text-white font-semibold transition">
              Ver projetos abertos
            </router-link>
          </article>

          <!-- Prestadores presenciais -->
          <article class="bg-white rounded-2xl border border-[#e0dcd6] p-7 shadow-sm hover:shadow-md transition flex flex-col h-full">
            <div class="w-14 h-14 rounded-2xl bg-[#152a34] flex items-center justify-center mb-5">
              <svg viewBox="0 0 24 24" class="w-7 h-7 text-[#b99a52]" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                <circle cx="12" cy="10" r="3" />
              </svg>
            </div>
            <h3 class="text-xl font-bold text-[#152a34] mb-3">Preciso presencial</h3>
            <p class="text-gray-600 text-sm mb-5">
              Reformas, manutenção, beleza, eventos, transporte, aulas —
              qualquer serviço que precise ser feito no local, perto de você.
            </p>
            <ul class="space-y-2.5 text-sm text-[#1f2937] mb-6">
              <li class="flex items-start gap-2">
                <span class="mt-0.5 text-[#0e7c5a]">✓</span>
                Busque por categoria e localização
              </li>
              <li class="flex items-start gap-2">
                <span class="mt-0.5 text-[#0e7c5a]">✓</span>
                Veja perfis, avaliações e portfólio
              </li>
              <li class="flex items-start gap-2">
                <span class="mt-0.5 text-[#0e7c5a]">✓</span>
                Agende horário e pague com segurança
              </li>
            </ul>
            <router-link to="/buscar-prestadores"
              class="mt-auto block w-full text-center px-4 py-2.5 rounded-xl bg-[#152a34] hover:bg-[#0f1f27] text-white font-semibold transition">
              Buscar perto de mim
            </router-link>
          </article>
        </div>
      </div>
    </section>

    <!-- ===================================================== -->
    <!-- COMO FUNCIONA — 4 passos                              -->
    <!-- ===================================================== -->
    <section id="como-funciona" class="py-20 bg-white px-4 sm:px-6">
      <div class="max-w-7xl mx-auto">
        <div class="text-center mb-14">
          <h2 class="text-3xl sm:text-4xl font-bold text-[#152a34] mb-3">Como funciona</h2>
          <p class="text-gray-600 max-w-2xl mx-auto">
            Em 4 passos simples você publica, escolhe, contrata e avalia —
            sem complicação, sem letras miúdas.
          </p>
        </div>

        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
          <!-- Passo 1 -->
          <div class="relative bg-[#f6f4f1] rounded-2xl p-6 border border-[#e0dcd6]">
            <div class="absolute -top-4 left-6 bg-[#b99a52] text-white text-xs font-bold tracking-widest px-3 py-1 rounded-full">
              PASSO 01
            </div>
            <div class="w-12 h-12 rounded-xl bg-white flex items-center justify-center mb-4 shadow-sm">
              <svg viewBox="0 0 24 24" class="w-6 h-6 text-[#152a34]" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
            </div>
            <h3 class="font-bold text-[#152a34] mb-2">Crie sua conta</h3>
            <p class="text-gray-600 text-sm">
              Cadastro gratuito em menos de um minuto, com verificação por e-mail.
            </p>
          </div>

          <!-- Passo 2 -->
          <div class="relative bg-[#f6f4f1] rounded-2xl p-6 border border-[#e0dcd6]">
            <div class="absolute -top-4 left-6 bg-[#b99a52] text-white text-xs font-bold tracking-widest px-3 py-1 rounded-full">
              PASSO 02
            </div>
            <div class="w-12 h-12 rounded-xl bg-white flex items-center justify-center mb-4 shadow-sm">
              <svg viewBox="0 0 24 24" class="w-6 h-6 text-[#152a34]" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="9" y1="13" x2="15" y2="13" />
                <line x1="9" y1="17" x2="15" y2="17" />
              </svg>
            </div>
            <h3 class="font-bold text-[#152a34] mb-2">Publique ou busque</h3>
            <p class="text-gray-600 text-sm">
              Crie um projeto remoto, navegue projetos abertos ou busque
              um prestador presencial perto de você.
            </p>
          </div>

          <!-- Passo 3 -->
          <div class="relative bg-[#f6f4f1] rounded-2xl p-6 border border-[#e0dcd6]">
            <div class="absolute -top-4 left-6 bg-[#b99a52] text-white text-xs font-bold tracking-widest px-3 py-1 rounded-full">
              PASSO 03
            </div>
            <div class="w-12 h-12 rounded-xl bg-white flex items-center justify-center mb-4 shadow-sm">
              <svg viewBox="0 0 24 24" class="w-6 h-6 text-[#152a34]" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
              </svg>
            </div>
            <h3 class="font-bold text-[#152a34] mb-2">Negocie no chat</h3>
            <p class="text-gray-600 text-sm">
              Converse direto com o profissional, alinhe escopo, prazo
              e valor — tudo registrado na plataforma.
            </p>
          </div>

          <!-- Passo 4 -->
          <div class="relative bg-[#f6f4f1] rounded-2xl p-6 border border-[#e0dcd6]">
            <div class="absolute -top-4 left-6 bg-[#b99a52] text-white text-xs font-bold tracking-widest px-3 py-1 rounded-full">
              PASSO 04
            </div>
            <div class="w-12 h-12 rounded-xl bg-white flex items-center justify-center mb-4 shadow-sm">
              <svg viewBox="0 0 24 24" class="w-6 h-6 text-[#152a34]" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M12 2 4 5v6c0 5 3.5 9.5 8 11 4.5-1.5 8-6 8-11V5l-8-3z" />
                <path d="m9 12 2 2 4-4" />
              </svg>
            </div>
            <h3 class="font-bold text-[#152a34] mb-2">Contrate com garantia</h3>
            <p class="text-gray-600 text-sm">
              Pagamento fica reservado e só é liberado quando o serviço
              é entregue e aprovado por você.
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- ===================================================== -->
    <!-- CATEGORIAS — vitrine de categorias atendidas          -->
    <!-- ===================================================== -->
    <section id="categorias" class="bg-[#152a34] text-white py-20 px-4 sm:px-6">
      <div class="max-w-7xl mx-auto">
        <div class="text-center mb-10">
          <h2 class="text-3xl sm:text-4xl font-bold mb-3">Categorias mais buscadas</h2>
          <p class="text-white/80 max-w-2xl mx-auto">
            Encontre o profissional certo para o que você precisa, em uma
            ampla variedade de áreas de atuação.
          </p>
        </div>

        <div class="flex flex-wrap justify-center gap-3 max-w-5xl mx-auto">
          <span
            v-for="cat in mockCategories" :key="cat"
            class="px-5 py-2.5 bg-white/10 hover:bg-[#b99a52] border border-white/15 hover:border-[#b99a52]
                   rounded-full text-sm font-medium transition cursor-default select-none">
            {{ cat }}
          </span>
        </div>
      </div>
    </section>

    <!-- ===================================================== -->
    <!-- SEGURANÇA / GARANTIA                                  -->
    <!-- ===================================================== -->
    <section id="seguranca" class="py-20 bg-[#f6f4f1] px-4 sm:px-6">
      <div class="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        <div>
          <span class="inline-block text-xs font-bold uppercase tracking-widest bg-[#f4efe6] text-[#6d5d3a] border border-[#d6c7a5] px-3 py-1 rounded-full mb-4">
            Garantia GetLance
          </span>
          <h2 class="text-3xl sm:text-4xl font-bold text-[#152a34] mb-4 leading-tight">
            Contrate com a segurança que você merece
          </h2>
          <p class="text-gray-600 mb-6">
            Todo pagamento fica reservado pela GetLance e só é liberado
            ao profissional após você aprovar a entrega. Se algo der errado,
            nosso time de suporte está pronto para mediar disputas.
          </p>

          <ul class="space-y-3">
            <li class="flex items-start gap-3">
              <span class="mt-0.5 inline-flex w-6 h-6 rounded-full bg-[#0e7c5a] text-white items-center justify-center text-xs font-bold">✓</span>
              <span class="text-[#1f2937]"><strong>Pagamento em garantia:</strong> dinheiro só é liberado após aprovação.</span>
            </li>
            <li class="flex items-start gap-3">
              <span class="mt-0.5 inline-flex w-6 h-6 rounded-full bg-[#0e7c5a] text-white items-center justify-center text-xs font-bold">✓</span>
              <span class="text-[#1f2937]"><strong>Profissionais verificados:</strong> conferimos identidade dos prestadores.</span>
            </li>
            <li class="flex items-start gap-3">
              <span class="mt-0.5 inline-flex w-6 h-6 rounded-full bg-[#0e7c5a] text-white items-center justify-center text-xs font-bold">✓</span>
              <span class="text-[#1f2937]"><strong>Sistema de disputas:</strong> mediação imparcial em caso de problemas.</span>
            </li>
            <li class="flex items-start gap-3">
              <span class="mt-0.5 inline-flex w-6 h-6 rounded-full bg-[#0e7c5a] text-white items-center justify-center text-xs font-bold">✓</span>
              <span class="text-[#1f2937]"><strong>Avaliações reais:</strong> apenas quem contratou pode avaliar.</span>
            </li>
          </ul>
        </div>

        <div class="relative">
          <div class="bg-white rounded-3xl shadow-xl border border-[#e0dcd6] p-8 relative z-10">
            <div class="flex items-center gap-4 mb-6">
              <div class="w-14 h-14 rounded-2xl bg-[#152a34] flex items-center justify-center">
                <svg viewBox="0 0 24 24" class="w-7 h-7 text-[#b99a52]" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M12 2 4 5v6c0 5 3.5 9.5 8 11 4.5-1.5 8-6 8-11V5l-8-3z" />
                </svg>
              </div>
              <div>
                <p class="text-xs uppercase tracking-wider text-[#6d5d3a] font-bold">Saldo em garantia</p>
                <p class="text-2xl font-bold text-[#152a34]">R$ 2.450,00</p>
              </div>
            </div>
            <div class="space-y-3 text-sm">
              <div class="flex items-center justify-between py-2 border-b border-gray-100">
                <span class="text-gray-600">Projeto: Logo + identidade visual</span>
                <span class="font-semibold text-[#0e7c5a]">Reservado</span>
              </div>
              <div class="flex items-center justify-between py-2 border-b border-gray-100">
                <span class="text-gray-600">Status</span>
                <span class="font-semibold text-[#152a34]">Aguardando entrega</span>
              </div>
              <div class="flex items-center justify-between py-2">
                <span class="text-gray-600">Liberação</span>
                <span class="font-semibold text-[#152a34]">Após sua aprovação</span>
              </div>
            </div>
            <div class="mt-5 p-3 bg-[#f4efe6] border border-[#d6c7a5] rounded-xl text-xs text-[#6d5d3a]">
              <strong>Seu dinheiro está seguro.</strong> Só é liberado quando
              você confirmar que o trabalho foi entregue conforme combinado.
            </div>
          </div>
          <!-- Decoração -->
          <div class="absolute -inset-4 bg-[#b99a52]/10 rounded-3xl -z-0 blur-2xl"></div>
        </div>
      </div>
    </section>

    <!-- ===================================================== -->
    <!-- DEPOIMENTOS                                            -->
    <!-- ===================================================== -->
    <section class="bg-white py-20 px-4 sm:px-6">
      <div class="max-w-7xl mx-auto">
        <div class="text-center mb-12">
          <h2 class="text-3xl sm:text-4xl font-bold text-[#152a34] mb-3">Histórias de sucesso</h2>
          <p class="text-gray-600">Quem já usa o GetLance recomenda.</p>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 max-w-7xl mx-auto">
          <div v-for="(testimony, i) in testimonials" :key="i"
            class="bg-[#f6f4f1] rounded-2xl shadow-sm p-7 hover:shadow-lg transition flex flex-col justify-between border border-[#e0dcd6]">
            <div class="flex items-start justify-between gap-4 mb-5">
              <div class="flex gap-1" aria-label="Avaliação 5 estrelas">
                <svg v-for="s in 5" :key="s" viewBox="0 0 24 24" class="h-4 w-4 text-[#b99a52]" fill="currentColor">
                  <path d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27Z" />
                </svg>
              </div>
              <span class="text-xs font-semibold text-[#6d5d3a] bg-[#f4efe6] border border-[#d6c7a5] px-2 py-0.5 rounded-full">
                {{ testimony.tag }}
              </span>
            </div>

            <p class="text-gray-700 text-base leading-relaxed mb-6">
              "{{ testimony.text }}"
            </p>

            <div class="flex items-center gap-3 pt-5 border-t border-black/5">
              <div class="h-11 w-11 rounded-full bg-[#152a34] text-[#b99a52] font-bold flex items-center justify-center text-lg">
                {{ testimony.name.charAt(0) }}
              </div>
              <div>
                <p class="font-semibold text-[#152a34] leading-tight">{{ testimony.name }}</p>
                <p class="text-xs text-gray-500">{{ testimony.role }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===================================================== -->
    <!-- CTA FINAL — Duplo                                     -->
    <!-- ===================================================== -->
    <section class="relative bg-[#b99a52] text-white py-16 px-4 sm:px-6 overflow-hidden">
      <div class="absolute inset-0 opacity-20"
        style="background-image: radial-gradient(circle at 30% 50%, #fff 0%, transparent 30%);">
      </div>
      <div class="relative max-w-4xl mx-auto text-center">
        <h2 class="text-3xl sm:text-4xl font-bold mb-3">Pronto para começar?</h2>
        <p class="text-white/90 mb-8 text-lg">
          Escolha por onde quer iniciar. Cadastro gratuito, sem cartão de crédito.
        </p>
        <div class="flex flex-col sm:flex-row gap-3 justify-center max-w-xl mx-auto">
          <button type="button" @click="goToPublishProject"
            class="bg-white text-[#152a34] px-7 py-3.5 rounded-xl font-semibold hover:bg-gray-100 transition shadow-lg">
            Sou contratante — publicar demanda
          </button>
          <router-link to="/buscar-prestadores"
            class="bg-[#152a34] hover:bg-[#0f1f27] text-white px-7 py-3.5 rounded-xl font-semibold transition shadow-lg border border-[#0f1f27]">
            Buscar profissional presencial
          </router-link>
        </div>
        <p class="mt-6 text-sm text-white/80">
          Ou
          <router-link to="/projetos" class="underline underline-offset-4 hover:text-white font-medium">
            navegue projetos abertos
          </router-link>
          se você é freelancer.
        </p>
      </div>
    </section>

    <AppFooter />
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { useRouter } from "vue-router";
import AppFooter from "@/components/AppFooter.vue";

const router = useRouter();
const showMenu = ref(false);
const showDropdown = ref(false);
const avatarWrapRef = ref(null);

const currentUserData = ref(null);

function loadCurrentUserData() {
  try {
    currentUserData.value = JSON.parse(localStorage.getItem("userData") || "null");
  } catch {
    currentUserData.value = null;
  }
}

const isAuthenticated = computed(() => {
  const token =
    currentUserData.value?.token ||
    currentUserData.value?.access_token ||
    currentUserData.value?.user?.token;
  return !!token;
});

const userName = computed(() => {
  return currentUserData.value?.user?.name || "Usuário";
});

const avatarLetter = computed(() => {
  const first = userName.value.trim().charAt(0);
  return (first || "U").toUpperCase();
});

function onDocumentClick(e) {
  if (avatarWrapRef.value && !avatarWrapRef.value.contains(e.target)) {
    showDropdown.value = false;
  }
}

function logout() {
  localStorage.removeItem("userData");
  currentUserData.value = null;
  showDropdown.value = false;
  showMenu.value = false;
  router.push("/");
}

function goToPublishProject() {
  // Marca intenção para que o RegisterProject não duplique o log de interesse
  try {
    sessionStorage.setItem("contractorInterest:skipNextRemoteMount", "1");
  } catch (_) {
    // ignore
  }
  router.push("/cadastre-seu-projeto");
}

function closeAndScroll(hash) {
  showMenu.value = false;
  setTimeout(() => {
    const el = document.querySelector(hash);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    else window.location.hash = hash;
  }, 50);
}

onMounted(() => {
  loadCurrentUserData();
  document.addEventListener("click", onDocumentClick);
});

onBeforeUnmount(() => {
  document.removeEventListener("click", onDocumentClick);
});

const mockCategories = [
  "Reformas e Construção",
  "Design Gráfico",
  "Programação",
  "Serviços Domésticos",
  "Beleza e Estética",
  "Manutenção e Reparos",
  "Transporte e Fretes",
  "Eventos e Festas",
  "Consultoria",
  "Marketing Digital",
  "Aulas Particulares",
  "Personal Trainer",
];

const testimonials = [
  {
    name: "Lucas Almeida",
    role: "Designer Freelancer",
    tag: "Freelancer",
    text: "Consegui meus primeiros clientes em menos de uma semana usando o GetLance. O chat integrado faz toda a diferença pra fechar negócio rápido.",
  },
  {
    name: "Mariana Souza",
    role: "Dona de loja online",
    tag: "Contratante",
    text: "Publiquei um projeto de logo e recebi 12 propostas no mesmo dia. A garantia de pagamento me deixa tranquila pra contratar.",
  },
  {
    name: "Carlos Mendes",
    role: "Eletricista",
    tag: "Presencial",
    text: "Como eletricista, comecei a receber chamados da minha cidade na primeira semana. Profissional verificado dá credibilidade pro cliente.",
  },
];
</script>

<style scoped>
@keyframes slideLeft {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(0);
  }
}

.animate-slideLeft {
  animation: slideLeft 0.25s ease-out;
}
</style>
